import styled from '@emotion/styled';
import { PlayerMicCheck } from '~/modules/Elements/VolumeIndicator';
import PlayersManager from '~/modules/Players/PlayersManager';

interface Props {
  names?: string[];
}

function MicCheck({ names }: Props) {
  return (
    <MicCheckContainer>
      {PlayersManager.getPlayers().map((player) => (
        <Indicator data-test={`mic-check-p${player.number}`} key={player.number}>
          <PlayerMicCheck playerNumber={player.number} />
          <span className="ph-no-capture">{names?.[player.number] ?? player.getName()}</span>
        </Indicator>
      ))}
    </MicCheckContainer>
  );
}

const MicCheckContainer = styled.div`
  display: flex;
  gap: 1.25rem;

  /* desktop/tablet */
  align-items: stretch;

  /* responsive móvil: apilar */
  @media (max-width: 640px) {
    flex-direction: column;
    gap: 0.75rem;
  }

  > div {
    flex: 1;
    min-width: 0;
  }
`;

const Indicator = styled.div`
  position: relative;
  border: 0.1rem solid rgba(255, 255, 255, 0.35);
  padding: 1rem 1.25rem;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(10px);

  text-align: center;
  gap: 1.25rem;
  font-size: 2rem;
  color: white;
  border-radius: 1rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
    padding: 0.85rem 1rem;
  }
`;

export default MicCheck;
